<template lang="html">
  <div
    class="component-dialog modal fade"
    :data-backdrop="backdrop ? 'true' : 'false'"
    tabindex="-1"
    role="dialog"
    :style="!backdrop && 'background-color: rgba(0, 0, 0, 0.5);'">
    <div class="modal-dialog" role="document">
      <div class="modal-content p-3">
        <h5 class="text-center h5 pt-3 pb-2">{{ header }}</h5>
        <button
          v-if="!noClose"
          class="close action-close text-secondary"
          data-dismiss="modal"
          aria-label="Close">
          <font-awesome-icon :icon="[ 'fas', 'times' ]" />
        </button>
        <div class="modal-body">
          <component :then="then" :props="props" v-bind:is="component" @close="close" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * You can use a dynamic instance importing "instance" and executing:
 * instance({
 *   header: 'My title',
 *   statement: 'the content',
 *   positiveLabel: 'Accept',
 *   ...otherProps
 * })
 */
import Vue from 'vue'
import $ from 'jquery'

const component = {
  props: {
    component: { type: Object },
    // If true needs to mount from the caller (instance.$mount(point))
    noMount: Boolean,
    // IF true avoids to show close button
    noClose: Boolean,
    // Title of dialog
    header: String,
    // Allows the backdrop to close the dialog
    backdrop: Boolean,
    then: { type: Function },
    props: Object
  },

  methods: {
    closeModal (e) {
      if (e.target === this.$el) $(this.$el).modal('hide')

      else e.stopPropagation()
    },

    close () {
      $(this.$el).modal('hide')
    }
  },

  created () {
    if (!this.noMount) this.$mount(this.$refs.dialogs)
  },

  mounted () {
    $(this.$el).modal('show')

    $(this.$el).on('hidden.bs.modal', e => {
      this.$el.remove()
      this.$destroy()
    })
  }
}

export default component

const ComponentClass = Vue.extend(component)

export const instance = props => new ComponentClass({ propsData: props })
</script>

<style lang="scss">
  @import '/../../scss/breakpoints';

  .component-dialog {
    & .modal-dialog {
      max-width: 460px;
    }

    & .action-close {
      position: absolute;
      top: 0.25rem;
      right: 0.5rem;
    }
  }

  @media screen and (max-width: map-get($grid-breakpoints, "sm")) {
    .component-dialog {
      & .btn {
        flex: 1;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/ComponentDialog.vue